export default __webpack_public_path__ + "static/media/text2INFO.ff12dd9d.glb";